import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink py-12 md:py-14" data-id="element-84" data-mp="32wd2qgad7ltj">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-85" data-mp="3gfsnyg23r0ok">
        <p className="font-display text-xl font-bold text-gold-500" data-id="element-86" data-mp="32nulup6t651w">
          El Puente del Adiós™ <span className="text-plum-300" data-id="element-87" data-mp="32m1ch24t96q7">© 2026</span>
        </p>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-plum-300" data-id="element-88" data-mp="36pzaf9iegbho">
          Material educativo y de apoyo. No reemplaza evaluación, diagnóstico, tratamiento
          psicológico ni atención de urgencia.
        </p>
      </div>
    </footer>;
}